@if (selectedOrgWithAccesses && selectedOrgWithAccesses.organization) {
  <section class="flex flex-col gap-6">
    <ng-container data-qa="org-info">
      <app-organization-info-card
        [isAbleToManageUsers]="isAbleToManageUsers"
        [organization]="selectedOrgWithAccesses.organization"
        [isOrgAdmin]="isOrgAdmin"
        (editOrg)="show.orgUpdate = true"
        (inviteMember)="showInviteMemberModal()"/>
      @if (show.orgUpdate) {
        <app-modal-organization-update
          [updatedOrganization]="selectedOrgWithAccesses.organization"
          (updatedOrg)="updatedOrg($event)"/>
      }
    </ng-container>

    @if (employees) {
      <app-team-table
        [employees]="employees"
        [isAbleToManageUsers]="isAbleToManageUsers"
        (deleteUser)="onDeleteUser($event)"
        (updateIsAbleToManageUsers)="onUpdateIsAbleToManageUsers($event)"
        (resendInvite)="onResendInvite($event)">
      </app-team-table>
    }
  </section>
}

@if (show.deleteEmployee) {
  <app-modal-dialog
    [header]="'Delete member'"
    [customUnderstandString]="deleteMemberText"
    [useStandardList]="false"
    [showIUnderstand]="false"
    (isConfirmed)="closeModalDeleteUser($event)"
  />
}

@if (show.inviteMember) {
  <app-modal-team-member
    (applyEmitter)="onInviteMember($event)"
    (cancelEmitter)="onCancelTeamMemberModal()"
  />
}
